<app-faq-title></app-faq-title>

<div class="faq-container">
  <div class="child-container-one">
    <!-- Searched -->
    <div class="searched">
      <div class="faq-item" *ngFor="let itemSearched of searchHelpList">
        <div
          class="title d-flex align-items-center justify-content-between faq-panel-header">
          <button class="item-title-btn" (click)="showItem($event)">
            {{ itemSearched.item }}
          </button>
          <button class="item-btn active" (click)="showItem($event)"></button>
        </div>
        <div class="item-child-container show">
          <div class="toggle-item">
            <button class="all-child-btn show" (click)="showAllChild($event)">
              {{ 'faq.showAll' | cxTranslate }}
            </button>
            <button class="all-child-btn" (click)="hideAllChild($event)">
              {{ 'faq.hideAll' | cxTranslate }}
            </button>
          </div>
          <div
            class="item-child"
            *ngFor="let itemChild of itemSearched.questions">
            <div class="item-child-question">
              <div class="toggle-item questions-section">
                <button
                  class="text-fixed-medium m-0 question-label"
                  (click)="toggleChild($event)">
                  {{ itemChild.question }}
                </button>
                <button
                  class="child-btn"
                  (click)="toggleChild($event)"></button>
              </div>
            </div>
            <div class="item-child-answer" id="{{ itemChild?.code }}">
              <app-accordian-answers
                [answers]="itemChild.answer"></app-accordian-answers>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FAQ List -->
    <div
      class="faq-item"
      *ngFor="let item of filteredItems | sort: 'asc' : 'item'"
      id="item">
      <div
        class="title d-flex align-items-center justify-content-between faq-panel-header">
        <button class="item-title-btn" (click)="showItem($event)">
          {{ item.item }}
        </button>
        <button class="item-btn" (click)="showItem($event)"></button>
      </div>
      <div class="item-child-container">
        <div class="toggle-item">
          <button class="all-child-btn show" (click)="showAllChild($event)">
            {{ 'faq.showAll' | cxTranslate }}
          </button>
          <button class="all-child-btn" (click)="hideAllChild($event)">
            {{ 'faq.hideAll' | cxTranslate }}
          </button>
        </div>
        <div class="item-child" *ngFor="let itemChild of item.questions">
          <div class="item-child-question">
            <div class="toggle-item questions-section">
              <button
                class="text-fixed-medium m-0 question-label"
                (click)="toggleChild($event)">
                {{ itemChild.question }}
              </button>
              <button class="child-btn" (click)="toggleChild($event)"></button>
            </div>
          </div>
          <div class="item-child-answer">
            <app-accordian-answers
              [answers]="itemChild.answer"></app-accordian-answers>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
